import { userHasForeignVatType } from '@ab-core-functions/user-permission';
import { formatPrice } from '@ab-core/functions';
import type { PositionPriceObject } from '@ab-core/graphql/dist/index';
import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';

export type UvpProps = Pick<PositionPriceObject, 'priceObject' | 'basePrice'> & {
    showUvpWithVat?: boolean;
    showUvpWithoutVat?: boolean;
};

export const Uvp: FC<UvpProps> = (props) => {
    const { priceObject, basePrice, showUvpWithVat, showUvpWithoutVat } = props;
    const hasForeignVatType = userHasForeignVatType();
    const isUvp =
        priceObject?.netRetailPrice && basePrice && priceObject?.netRetailPrice?.centAmount - basePrice?.centAmount > 1;

    if (!isUvp) {
        return <></>;
    }

    return (
        <>
            {priceObject?.grossRetailPrice && showUvpWithVat && (
                <div
                    className="flex-justify-content-space-between"
                    {...getTestIdProp('product-card-price-with-vat-uvp')}
                >
                    <Text>UVP inkl. MwSt.</Text>
                    <Text className="text-right">{formatPrice(priceObject.grossRetailPrice)}</Text>
                </div>
            )}

            {!hasForeignVatType && priceObject?.netRetailPrice && showUvpWithoutVat && (
                <div
                    className="flex-justify-content-space-between"
                    {...getTestIdProp('product-card-price-without-vat-uvp')}
                >
                    <Text>UVP zzgl. MwSt.</Text>
                    <Text className="text-right">{formatPrice(priceObject.netRetailPrice)}</Text>
                </div>
            )}
        </>
    );
};
